import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { getValueFromResource } from '../../common/timeLiveFunction';
import fetchIntegrationAPI from '../../common/fetchIntegrationAPI';
import DropdownOptions from './Dropdownoptions';

interface SelectionOption {
    label: string;
    value: number | null;
}

interface SelectionProjectOption {
    label: string;
    value: number | null;
    clientId: any;
}

const CustomDropdownModal = (props: any) => {
    const getInitialCurrentStep = () => {
        if (ShowProjectForTimeOff && showClientInTimesheet) {
            return 1;
        } else if (ShowProjectForTimeOff && !showClientInTimesheet) {
            return 2;
        } else if (showClientInTimesheet) {
            return 1;
        } else {
            return 2;
        }
    }

    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const { setDropdownVisible, onSelectionComplete, preSelectedData } = props;
    const rowId = 1
    const { t } = useTranslation();
    const { accountEmployeeId, ShowProjectForTimeOff } = useAppSelector((state) => state.timesheet);
    const { showTimeOffTypesBy, showClientInTimesheet, showCostCenterInTimeSheet, showWorkTypeInTimeSheet } = useAppSelector((state) => state.globalState)
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [currentStep, setCurrentStep] = useState<number>(getInitialCurrentStep());
    const [selectedClient, setSelectedClient] = useState<SelectionOption>(
        preSelectedData?.client || { label: '', value: null }
    );
    const [selectedProject, setSelectedProject] = useState<SelectionProjectOption>(
        preSelectedData?.project || { label: '', value: null, clientId: null }
    );
    const [selectedTask, setSelectedTask] = useState<SelectionOption>(
        preSelectedData?.task || { label: '', value: null }
    );
    const [selectedCost, setSelectedCost] = useState<SelectionOption>(
        preSelectedData?.cost || { label: '', value: null }
    );
    const [selectedWorktype, setSelectedWorktype] = useState<SelectionOption>(
        preSelectedData?.worktype || { label: '', value: null }
    );
    const [stepOrder, setStepOrder] = useState([
        { step: 1, fieldIdName: "AccountClientId", fieldTextName: 'ClientName', required: null, data: [], selectedValue: 0, selectedText: '' },
        { step: 2, fieldIdName: "AccountProjectId", fieldTextName: 'ProjectName', required: "AccountClientId", data: [], selectedValue: 0, selectedText: '' },
        { step: 3, fieldIdName: "AccountProjectTaskId", fieldTextName: 'TaskName', required: "AccountProjectId", data: [], selectedValue: 0, selectedText: '' },
        { step: 4, fieldIdName: "AccountCostCenterId", fieldTextName: 'CostCenter', required: null, data: [], selectedValue: 0, selectedText: '' },
        { step: 5, fieldIdName: "AccountWorkTypeId", fieldTextName: 'WorkType', required: null, data: [], selectedValue: 0, selectedText: '' },
        { step: 6, fieldIdName: "AccountTimeOffTypeId", fieldTextName: 'AccountTimeOffType', required: null, data: [], selectedValue: 0, selectedText: '' }
    ]);

    const [updatedObject, setUpdatedObject] = useState<any>(() => {
        const initialObject: any = {};
        if (preSelectedData?.client?.value) {
            initialObject.AccountClientId = preSelectedData.client.value;
            initialObject.ClientName = preSelectedData.client.label;
        }
        if (preSelectedData?.project?.value) {
            initialObject.AccountProjectId = preSelectedData.project.value;
            initialObject.ProjectName = preSelectedData.project.label;
        }
        if (preSelectedData?.task?.value) {
            initialObject.AccountProjectTaskId = preSelectedData.task.value;
            initialObject.TaskName = preSelectedData.task.label;
        }
        if (preSelectedData?.cost?.value) {
            initialObject.AccountCostCenterId = preSelectedData.cost.value;
            initialObject.CostCenter = preSelectedData.cost.label;
        }
        if (preSelectedData?.worktype?.value) {
            initialObject.AccountWorkTypeId = preSelectedData.worktype.value;
            initialObject.WorkType = preSelectedData.worktype.label;
        }
        return initialObject;
    });
    
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
    const dispatch = useAppDispatch();

    const getMaxStep = () => {
        if (showWorkTypeInTimeSheet) {
            return 5;
        } else if (showCostCenterInTimeSheet) {
            return 4;
        } else {
            return 3;
        }
    }

    const getDataByCurrentStep = (step: number) => {
        if (step == currentStep) {
            return stepOrder.find(x => x.step == currentStep)!.data;
        }
        else {
            return [];
        }
    }

    const handleTab = (step: number) => {
        const activeStep = stepOrder.find(x => x.step == step)!;
        if (activeStep.required != null) {
            if (updatedObject[activeStep.required] == 0)
                return;
        }
        setCurrentStep(step);
        setSearch("");
    }

    useEffect(() => {
        if (currentStep > getMaxStep()) {
            setDropdownVisible(false);
        } else {
            getDropdownData();
        }
    }, [currentStep])

    useEffect(() => {
        if (currentStep === 1 && defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        } else if (currentStep === 2 && defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        } else if (currentStep === 3 && defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        } else if (currentStep === 4 && defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        } else if (currentStep === 5 && defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        } else if (currentStep === 6 && defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
    }, [currentStep]);

    const onSearchChange = (e: any) => {
        setSearch(e.target.value);
    }

    const stepHandler = (step: number, e: any) => {
        if (showCostCenterInTimeSheet == false && step === 4) {
            setCurrentStep(step);
        }
        e.currentTarget.querySelector("input").checked = true;
        setSearch("");

        if (showClientInTimesheet && currentStep == 1) {
            setIsLoading(true);
            setCurrentStep(step);
            const index = stepOrder.findIndex((record) => record.step === currentStep);
            const newArray = [...stepOrder];
            newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
            newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;

            const clientSelection = {
                label: newArray[index].selectedText,
                value: newArray[index].selectedValue
            };
            setSelectedClient(clientSelection);
            onSelectionComplete({
                client: clientSelection,
                project: selectedProject,
                task: selectedTask,
                cost: selectedCost,
                worktype: selectedWorktype
            });

            setStepOrder(newArray);
            setUpdatedObject({
                ...updatedObject,
                [newArray[index].fieldIdName]: Number(e.currentTarget.querySelector("input").value),
                [newArray[index].fieldTextName]: e.currentTarget.querySelector(".name").innerText
            });
        } else if (currentStep == 2) {
            setIsLoading(true);
            setCurrentStep(step);
            const index = stepOrder.findIndex((record) => record.step === currentStep);
            const newArray = [...stepOrder];
            newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
            newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;
            const selectedProjectClientId = newArray[index]?.data?.find((item: any) => item?.AccountProjectId === newArray[index].selectedValue)
            const projectSelection = {
                label: newArray[index].selectedText,
                value: newArray[index].selectedValue,
                clientId: selectedProjectClientId?.['AccountClientId']
            };
            setSelectedProject(projectSelection);
            onSelectionComplete({
                client: selectedClient,
                project: projectSelection,
                task: selectedTask,
                cost: selectedCost,
                worktype: selectedWorktype
            });

            setStepOrder(newArray)
            var FieldIdName = newArray[index].fieldIdName;
            var FieldTextName = newArray[index].fieldTextName;
            let AccountProjectId = Number(e.currentTarget.querySelector("input").value)
            let AccountClientId = newArray[index].data.filter((item: any) => item.AccountProjectId === AccountProjectId)[0]["AccountClientId"];
            showClientInTimesheet ?
                setUpdatedObject({ ...updatedObject, [FieldIdName]: AccountProjectId, [FieldTextName]: e.currentTarget.querySelector(".name").innerText }) :
                setUpdatedObject({ ...updatedObject, [FieldIdName]: AccountProjectId, [FieldTextName]: e.currentTarget.querySelector(".name").innerText, AccountClientId: AccountClientId });
        } else if (currentStep == 3) {
            setIsLoading(true);
            setCurrentStep(step);
            const index = stepOrder.findIndex((record) => record.step === currentStep);
            const newArray = [...stepOrder];
            newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
            newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;

            const taskSelection = {
                label: newArray[index].selectedText,
                value: newArray[index].selectedValue
            };
            setSelectedTask(taskSelection);
            onSelectionComplete({
                client: selectedClient,
                project: selectedProject,
                task: taskSelection,
                cost: selectedCost,
                worktype: selectedWorktype
            });

            setStepOrder(newArray)
            var FieldIdName = newArray[index].fieldIdName;
            var FieldTextName = newArray[index].fieldTextName;
            var IsBillable = newArray[index].data.filter((x: any) => x.AccountProjectTaskId == Number(e.currentTarget.querySelector("input").value))[0]["IsBillable"];
            setUpdatedObject({ ...updatedObject, [FieldIdName]: Number(e.currentTarget.querySelector("input").value), [FieldTextName]: e.currentTarget.querySelector(".name").innerText, "IsBillable": IsBillable });
        } else if (showCostCenterInTimeSheet && currentStep == 4) {
            setIsLoading(true);
            setCurrentStep(step);
            const index = stepOrder.findIndex((record) => record.step === currentStep);
            const newArray = [...stepOrder];
            newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
            newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;

            const costSelection = {
                label: newArray[index].selectedText,
                value: newArray[index].selectedValue
            };
            setSelectedCost(costSelection);
            onSelectionComplete({
                client: selectedClient,
                project: selectedProject,
                task: selectedTask,
                cost: costSelection,
                worktype: selectedWorktype
            });

            setStepOrder(newArray)
            var FieldIdName = newArray[index].fieldIdName;
            var FieldTextName = newArray[index].fieldTextName;
            setUpdatedObject({ ...updatedObject, [FieldIdName]: Number(e.currentTarget.querySelector("input").value), [FieldTextName]: e.currentTarget.querySelector(".name").innerText });
        } else if (showWorkTypeInTimeSheet && currentStep == 5) {
            setIsLoading(true);
            setCurrentStep(step);
            const index = stepOrder.findIndex((record) => record.step === currentStep);
            const newArray = [...stepOrder];
            newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
            newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;

            const worktypeSelection = {
                label: newArray[index].selectedText,
                value: newArray[index].selectedValue
            };
            setSelectedWorktype(worktypeSelection);
            onSelectionComplete({
                client: selectedClient,
                project: selectedProject,
                task: selectedTask,
                cost: selectedCost,
                worktype: worktypeSelection
            });

            setStepOrder(newArray)
            var FieldIdName = newArray[index].fieldIdName;
            var FieldTextName = newArray[index].fieldTextName;
            setUpdatedObject({ ...updatedObject, [FieldIdName]: Number(e.currentTarget.querySelector("input").value), [FieldTextName]: e.currentTarget.querySelector(".name").innerText });
        }
    }

    const getDropdownData = () => {
        const { AccountClientId, AccountProjectId } = updatedObject;
        if (currentStep == 1) {
            fetchIntegrationAPI(`api/Client/${AccountEmployeeId}/${AccountClientId ?? 0}`, 'GET', "", true)
                .then(res => res.json())
                .then((res) => {
                    setIsLoading(false);
                    const index = stepOrder.findIndex((record) => record.step === currentStep);
                    const newArray = [...stepOrder];
                    newArray[index].data = res.Data;
                    setStepOrder(newArray)
                }, (error) => console.log(error));
        } else if (currentStep == 2) {
            if (showClientInTimesheet && !AccountClientId) {
                return;
            }
            const project_id = (AccountProjectId != undefined ? AccountProjectId : 0);
            const url = `${(showClientInTimesheet ? AccountClientId : project_id)}/${AccountEmployeeId}/${licenseExpireFlag}`;
            fetchIntegrationAPI(`api/Project/${url}`, 'GET', "", true)
                .then(res => res.json())
                .then((res) => {
                    setIsLoading(false);
                    const index = stepOrder.findIndex((record) => record.step === currentStep);
                    const newArray = [...stepOrder];
                    newArray[index].data = res.Data;
                    setStepOrder(newArray)
                })
                .catch((error) => {
                })
        } else if (currentStep == 3) {
            const url = `${AccountProjectId}/${AccountEmployeeId}`;
            if (AccountProjectId) {
                fetchIntegrationAPI(`api/Tasks/${url}`, 'GET', "", true)
                    .then(res => res.json())
                    .then((res) => {
                        setIsLoading(false);
                        const index = stepOrder.findIndex((record) => record.step === currentStep);
                        const newArray = [...stepOrder];
                        newArray[index].data = res.Data;
                        setStepOrder(newArray)
                    }, (error) => console.log(error));
            }
        } else if (currentStep == 4) {
            fillCostCenterDropdown();
        } else if (currentStep == 5) {
            fillWorkTypeDropdown();
        }
    }

    const fillWorkTypeDropdown = () => {
        if (showWorkTypeInTimeSheet) {
            fetchIntegrationAPI("api/WorkTypes", 'GET', "", true)
                .then(res => res.json())
                .then((res) => {
                    setIsLoading(false);
                    const index = stepOrder.findIndex((record) => record.step === currentStep);
                    const newArray = [...stepOrder];
                    newArray[index].data = res.Data.length > 0 && res.Data[0].hasOwnProperty('Message') ? [] : res.Data;
                    setStepOrder(newArray)
                }, (error) => console.log(error));
        }
    }

    const fillCostCenterDropdown = () => {
        const { AccountProjectId, AccountProjectTaskId } = updatedObject;
        const url = `${accountEmployeeId}/${AccountProjectId}/${AccountProjectTaskId}`;
        if (showCostCenterInTimeSheet && AccountProjectId && AccountProjectTaskId) {
            fetchIntegrationAPI(`api/CostCenter/${url}`, "GET", "", true)
                .then(res => res.json())
                .then((res) => {
                    setIsLoading(false);
                    const index = stepOrder.findIndex((record) => record.step === currentStep);
                    const newArray = [...stepOrder];
                    newArray[index].data = res.Data.length > 0 && res.Data[0].hasOwnProperty('Message') ? [] : res.Data;
                    setStepOrder(newArray)
                }, (error) => console.log(error));
        }
    }

    return (
        <div className={"timelive-mega-picker"} style={{ willChange: "transform", position: 'fixed' }}>
            <nav className={"nav nav-pills"}>
                {((showClientInTimesheet) || (showClientInTimesheet)) && <span onClick={e => handleTab(1)} className={"nav-link " + (currentStep == 1 ? "active" : "")} style={{ borderRadius: 0 }}>{getValueFromResource('Client', dispatch, t)}</span>}
                {<span onClick={e => handleTab(2)} className={"nav-link " + (currentStep == 2 ? "active" : "")} data-tab="pills-projects" style={{ borderRadius: 0 }}>{getValueFromResource('Project', dispatch, t)}</span>}
                {<span onClick={e => handleTab(3)} className={"nav-link " + (currentStep == 3 ? "active" : "")} data-tab="pills-tasks" style={{ borderRadius: 0 }}>{getValueFromResource('Task', dispatch, t)}</span>}
                {showCostCenterInTimeSheet && <span onClick={e => handleTab(4)} className={"nav-link " + (currentStep == 4 ? "active" : "")} data-tab="pills-cost-center" data-step="4" style={{ borderRadius: 0 }}>{getValueFromResource('Cost Center', dispatch, t)}</span>}
                {showWorkTypeInTimeSheet && <span onClick={e => handleTab(5)} className={"nav-link " + (currentStep == 5 ? "active" : "")} data-tab="pills-work-type" data-step="5" style={{ borderRight: 0 }}>{getValueFromResource('Work Type', dispatch, t)}</span>}
            </nav>
            <div className={"tmg--search"} >
                <div className={"input-group"} style={{ borderBottom: "1px solid #e5e5e5"}}>
                    <span className={"search--icon"}><i className={"fa fa-search"}></i></span>
                    <input type="text" onChange={onSearchChange} value={search} className={"form-control shadow-none"} ref={defaultFocusRef} placeholder={getValueFromResource("Search", dispatch, t)} style={{ fontSize: '1.1rem', height: 46 }} />
                </div>
            </div>
            <div className={"tab-content"} style={{ maxHeight: 300, overflowY: 'auto' }}>
                {showClientInTimesheet &&
                    <div className={"tab-pane tmg--tab-pane fade " + (currentStep == 1 ? "show active" : "")} role="tabpanel">
                        <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                            <tbody>
                                {isLoading &&
                                    <tr>
                                        <td className="spinner-border" role="status" style={{ display: (isLoading ? 'flex' : 'none') }}>
                                            <span className="visually-hidden">
                                                {getValueFromResource('Loading...', dispatch, t)}
                                            </span>
                                        </td>
                                    </tr>
                                }
                                {Array.isArray(getDataByCurrentStep(1)) &&  getDataByCurrentStep(1).length > 0 && (
                                getDataByCurrentStep(1)?.filter((x: any) => x.PartyName.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                    ?.map((x: any, i) => {
                                        return (
                                            <DropdownOptions
                                                key={i}
                                                type={"client"}
                                                id={x.AccountPartyId}
                                                name={x.PartyName}
                                                code=""
                                                checked={x.AccountPartyId == updatedObject.AccountClientId}
                                                clickHandler={(e: any) => {
                                                    stepHandler(2, e)
                                                }}
                                            />)
                                    }
                                    ))}
                                {!isLoading && Array.isArray(getDataByCurrentStep(1)) && getDataByCurrentStep(1).length == 0 &&
                                    <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                        <td>
                                            {getValueFromResource('No Result(s) Found', dispatch, t)}
                                        </td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                }
                <div className={"tab-pane tmg--tab-pane fade " + (currentStep == 2 ? "show active" : "")} role="tabpanel">
                    <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                        <tbody>
                            {isLoading &&
                                <tr>
                                    <td>
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </span>
                                    </td>
                                </tr>
                            }
                            {Array.isArray(getDataByCurrentStep(2)) && getDataByCurrentStep(2).length > 0 && (
                                getDataByCurrentStep(2)?.filter((x: any) => x.ProjectName.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                ?.map((x: any, i) =>
                                    <DropdownOptions
                                        key={i}
                                        type={"project"}
                                        id={x.AccountProjectId}
                                        name={x.ProjectName}
                                        code={x.ProjectCode}
                                        checked={x.AccountProjectId == updatedObject.AccountProjectId}
                                        clickHandler={(e: any) => stepHandler(3, e)}
                                    />
                                ))}
                            {!isLoading && Array.isArray(getDataByCurrentStep(2)) && getDataByCurrentStep(2).length == 0 &&
                                <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                    <td>
                                        {getValueFromResource('No Result(s) Found', dispatch, t)}
                                    </td>
                                </tr>}
                        </tbody>
                    </table>
                </div>
                <div className={"tab-pane tmg--tab-pane fade " + (currentStep == 3 ? "show active" : "")} role="tabpanel">
                    <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                        <tbody>
                            {Array.isArray(getDataByCurrentStep(3)) && getDataByCurrentStep(3).length > 0 && (
                                getDataByCurrentStep(3)
                                    .filter((x: any) => x.TaskName?.toLowerCase().includes(search.toLowerCase()))
                                    .map((x: any, i: number) => (
                                        <DropdownOptions
                                            key={i}
                                            type="task"
                                            id={x.AccountProjectTaskId}
                                            name={x.TaskName}
                                            code=""
                                            checked={x.AccountProjectTaskId === updatedObject.AccountProjectTaskId}
                                            clickHandler={(e: any) => stepHandler(!showCostCenterInTimeSheet ? 5 : 4, e)}
                                        />
                                    ))
                            )}

                            {!isLoading && Array.isArray(getDataByCurrentStep(3)) && getDataByCurrentStep(3).length === 0 && (
                                <tr className="selection--option" style={{ textAlign: "center" }}>
                                    <td>{getValueFromResource('No Result(s) Found', dispatch, t)}</td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>
                {showCostCenterInTimeSheet &&
                    <div className={"tab-pane tmg--tab-pane fade" + (currentStep == 4 ? "show active" : "")} role="tabpanel">
                        <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                            <tbody>
                                {isLoading &&
                                    <tr>
                                        <td>
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        </td>
                                    </tr>
                                }
                                {Array.isArray(getDataByCurrentStep(4)) && getDataByCurrentStep(4).length > 0 &&( getDataByCurrentStep(4)
                                    ?.filter((x: any) => x.AccountCostCenter.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                    ?.map((x: any, i) =>
                                        <DropdownOptions
                                            key={i}
                                            type={"task"}
                                            id={x.AccountCostCenterId}
                                            name={x.AccountCostCenter}
                                            code={x.AccountCostCenterCode}
                                            checked={x.AccountCostCenterId == updatedObject.AccountCostCenterId}
                                            clickHandler={(e: any) => stepHandler(5, e)}
                                        />
                                    ))}
                                {!isLoading && Array.isArray(getDataByCurrentStep(4)) && getDataByCurrentStep(4).length == 0 &&
                                    <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                        <td>
                                            {getValueFromResource('No Result(s) Found', dispatch, t)}
                                        </td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                }
                {showWorkTypeInTimeSheet &&
                    <div className={"tab-pane tmg--tab-pane fade" + (currentStep == 5 ? "show active" : "")} role="tabpanel">
                        <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                            <tbody>
                                {isLoading &&
                                    <tr>
                                        <td>
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        </td>
                                    </tr>
                                }
                                {Array.isArray(getDataByCurrentStep(5)) && getDataByCurrentStep(5).length > 0 && getDataByCurrentStep(5)
                                    ?.filter((x: any) => x.AccountWorkType.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                    ?.map((x: any, i) =>
                                        <DropdownOptions
                                            key={i}
                                            type={"task"}
                                            id={x.AccountWorkTypeId}
                                            name={x.AccountWorkType}
                                            code={x.AccountWorkTypeCode}
                                            checked={x.AccountWorkTypeId == updatedObject.AccountWorkTypeId}
                                            clickHandler={(e: any) => stepHandler(6, e)}
                                        />
                                    )}
                                {!isLoading && Array.isArray(getDataByCurrentStep(5))  && getDataByCurrentStep(5).length == 0 &&
                                    <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                        <td>
                                            {getValueFromResource('No Result(s) Found', dispatch, t)}
                                        </td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                }
                <div className={"tab-pane tmg--tab-pane fade" + (currentStep == 6 ? "show active" : "")} role="tabpanel">
                    <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                        <tbody>
                            {isLoading &&
                                <tr>
                                    <td>
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </span>
                                    </td>
                                </tr>
                            }
                            {Array.isArray(getDataByCurrentStep(6))  && getDataByCurrentStep(6).length > 0 && getDataByCurrentStep(6)
                                ?.filter((x: any) => x.AccountTimeOffType.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                ?.map((x: any, i) =>
                                    <DropdownOptions
                                        key={i}
                                        type={"task"}
                                        id={x.AccountTimeOffTypeId}
                                        name={x.AccountTimeOffType}
                                        code=""
                                        checked={x.AccountTimeOffTypeId == updatedObject.AccountTimeOffTypeId}
                                        clickHandler={(e: any) => stepHandler(7, e)}
                                    />
                                )}
                            {!isLoading && Array.isArray(getDataByCurrentStep(6))  && getDataByCurrentStep(6).length == 0 &&
                                <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                    <td>
                                        {getValueFromResource('No Result(s) Found', dispatch, t)}
                                    </td>
                                </tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default CustomDropdownModal